import script from "./MeetingDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingDetailsModal.vue?vue&type=style&index=0&id=6e2730ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2730ef"]])

export default __exports__